import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import { MagnifyingGlass, ArrowLeft, ChatCircleText, Phone } from "@phosphor-icons/react";

const C = { bg: "#070B16", surface: "#0F1729", card: "#111a2e", green: "#10B981", orange: "#FF7A00", text: "#F8FAFC", sub: "#94A3B8", border: "rgba(255,255,255,0.10)" };
const HEAD = { fontFamily: "'Outfit', sans-serif" };

export default function Rates() {
  const [rates, setRates] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/rates/public").then(({ data }) => setRates(data.rates || [])).catch(() => setRates([])).finally(() => setLoading(false)); }, []);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return rates;
    return rates.filter((r) => r.name.toLowerCase().includes(s) || (r.dial || "").includes(s) || r.code.toLowerCase().includes(s));
  }, [q, rates]);

  return (
    <div style={{ background: C.bg, color: C.text, fontFamily: "'Manrope',sans-serif" }} className="min-h-screen">
      <header className="sticky top-0 z-40 border-b bg-[#0B1220]/85 backdrop-blur-xl" style={{ borderColor: C.border }}>
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3 sm:px-6">
          <Link to="/" data-testid="rates-back" className="flex items-center gap-2 text-sm font-semibold text-slate-300 hover:text-white"><ArrowLeft size={18} /> Back</Link>
          <Link to="/register" data-testid="rates-create-account" className="rounded-full px-4 py-2.5 text-sm font-bold text-white" style={{ background: C.orange }}>Create Free Account</Link>
        </div>
      </header>

      <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6" data-testid="rates-page">
        <h1 style={HEAD} className="text-3xl font-black tracking-tight sm:text-4xl">Calling Rates</h1>
        <p className="mt-2 text-base" style={{ color: C.sub }}>Transparent, per-minute pricing to call any destination worldwide. No account needed to browse.</p>

        <div className="mt-5 flex items-center gap-2 rounded-2xl border bg-[#111a2e] px-4 py-3" style={{ borderColor: C.border }}>
          <MagnifyingGlass size={20} style={{ color: C.sub }} />
          <input data-testid="rates-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search a country or dialing code…"
            className="w-full bg-transparent text-base outline-none placeholder:text-slate-500" />
        </div>

        <div className="mt-4 flex items-center gap-2 rounded-2xl border px-4 py-3 text-sm" style={{ borderColor: C.border, background: "#10B9810f", color: C.green }} data-testid="rates-free-note">
          <ChatCircleText size={18} weight="fill" /> Calls &amp; messages between iYeneh members are always free.
        </div>

        {loading ? (
          <div className="mt-8 text-center text-sm" style={{ color: C.sub }}>Loading rates…</div>
        ) : (
          <div className="mt-6 overflow-hidden rounded-2xl border" style={{ borderColor: C.border }}>
            {filtered.map((r, i) => (
              <div key={r.code} data-testid={`rate-${r.code}`} className="flex items-center justify-between px-4 py-3.5" style={{ background: i % 2 ? "#0F1729" : "#111a2e", borderTop: i ? `1px solid ${C.border}` : "none" }}>
                <div className="flex items-center gap-3">
                  <span className="text-xl">{r.flag}</span>
                  <div>
                    <p className="font-semibold">{r.name}</p>
                    <p className="text-xs" style={{ color: C.sub }}>{r.dial}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p style={{ ...HEAD, color: C.green }} className="font-extrabold">${(r.retail_cpm / 100).toFixed(2)}</p>
                  <p className="text-xs" style={{ color: C.sub }}>per minute</p>
                </div>
              </div>
            ))}
            {filtered.length === 0 && <div className="px-4 py-10 text-center text-sm" style={{ color: C.sub }}>No destinations match “{q}”.</div>}
          </div>
        )}

        <div className="mt-8 flex flex-col items-center gap-3 rounded-3xl border p-7 text-center sm:flex-row sm:justify-between sm:text-left" style={{ background: C.surface, borderColor: C.border }}>
          <div className="flex items-center gap-3"><Phone size={26} weight="fill" style={{ color: C.orange }} /><p style={HEAD} className="text-lg font-extrabold">Ready to start calling? Get $1 free credit.</p></div>
          <Link to="/register" className="whitespace-nowrap rounded-full px-7 py-3.5 font-bold text-white" style={{ background: C.orange }}>Create Free Account</Link>
        </div>
      </div>
      <WhatsAppFab />
    </div>
  );
}
